// extracted by mini-css-extract-plugin
export default {"tooltip":"MR-z","arrow":"NR-z"};